import { apiRequest } from '../apiRequest';

export const createTelegramDestinationApi = async (payload) => {
  return apiRequest('/admin/notification/telegram-destinations', {
    method: 'POST',
    body: payload,
    defaultErrorMessage: 'Failed to create Telegram destination',
  });
};
